<template>
  <div :class="classes">
    <pt-page-title title="咨询师详情"></pt-page-title>
    <div v-if="currentCounselor && currentCounselor.workNumber">
      <pt-sub-title title="咨询师信息"></pt-sub-title>
      <pt-form-item label="工号：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentCounselor.workNumber}}</span>
      </pt-form-item>
      <pt-form-item label="姓名：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentCounselor.firstName}}</span>
      </pt-form-item>
      <pt-form-item label="商城用户：" :labelWidth="labelWidth" :lineHeight="lineHeight"
                    v-if="userFullName">
        <span>{{userFullName}}</span>
      </pt-form-item>
      <pt-form-item label="职位：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentCounselor.positionName}}</span>
      </pt-form-item>
      <tr v-if="currentCounselor.hospitals.length">
        <td style="width:100px;text-align:right">执业医院：</td>
        <td>
          <div :class="$style['specification-table-div']" class="page-background">
            <table :class="$style['specification-table']">
              <th>
              <td>医院名称</td>
              <td>分/子公司 </td>
              <td>地区</td>
              </th>
              <tr v-for="(item,index) in currentCounselor.hospitals" :key="index">
                <td>{{item.name}}</td>
                <td>{{item.branchName}} </td>
                <td>{{item.address}}</td>
              </tr>
            </table>
          </div>
        </td>
      </tr>
      <pt-form-item label="执业医院：" :labelWidth="labelWidth" :lineHeight="lineHeight" v-else>
        <span>无</span>
      </pt-form-item>
      <pt-form-item label="办公电话：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentCounselor.officePhone}}</span>
      </pt-form-item>
      <pt-form-item label="手机：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentCounselor.mobile}}</span>
      </pt-form-item>
      <pt-form-item label="微信：" :labelWidth="labelWidth">
        <span>{{currentCounselor.wechatId?currentCounselor.wechatId:'--'}}</span>
      </pt-form-item>
      <pt-form-item label="公司：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{currentCounselor.companyName}}</span>
      </pt-form-item>
      <pt-form-item label="照片：" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <pt-img :src="currentCounselor.headImage" :isPublic="true" :class="$style.quaImages"
                v-if="currentCounselor.headImage"></pt-img>
        <span v-else>无</span>
      </pt-form-item>
    </div>
    <div class="marginTop">
      <el-button type="primary" @click="goEdit(currentCounselor)">编辑</el-button>
      <el-button type="primary" @click="tocheackInfo" v-if="userId">查看用户信息</el-button>
      <el-button type="primary" @click="createQrCode" v-if="canCreateQrCode"
                 :loading="qrCodeLoading">生成支付静态码</el-button>
      <template v-if="paymentCodes">
        <el-button type="primary" @click="getQRcode(item)" v-for="(item,index) in paymentCodeNames"
                   :key="index">下载{{ item.type }}二维码</el-button>
      </template>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import { hasPermissions } from 'utils/permissions'
const prefixCls = 'pt-counselor-detail'
const PERM_USER_MANAGEMENT = 'PERM_USER_MANAGEMENT'
export default {
  name: 'pt-counselor-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    has_USER_MANAGEMENT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_USER_MANAGEMENT)
    },
    // 是否可生成二维码
    canCreateQrCode () {
      return this.has_USER_MANAGEMENT
    },
    paymentCodes () {
      return this.currentCounselor.paymentCodes
    },
    paymentCodeNames () {
      let names = []
      if (this.paymentCodes && this.paymentCodes.length) {
        names = this.paymentCodes.map(item => {
          return { url: item, type: item.substring(item.lastIndexOf('_') + 1) }
        })
      }
      return names
    }
  },
  props: {
    counselor: {
      type: Object,
      default: () => { }
    },
    userId: {
      type: String,
      default: ''
    },
    userFullName: {
      type: String,
      default: ''
    },
    qrCodeLoading: Boolean
  },
  data () {
    return {
      currentCounselor: this.counselor,
      labelWidth: '100px',
      lineHeight: '26'
    }
  },
  watch: {
    counselor (val) {
      this.currentCounselor = val
    }
  },
  methods: {
    goEdit (data) {
      this.$router.push(`/counselor-form/true/${data.id}`)
    },
    tocheackInfo () {
      this.$router.push('/all-customer/customer-detail/' + this.userId + '?state=basic-message')
    },
    createQrCode () {
      this.$emit('createQrCode')
    },
    getQRcode (item) {
      location.href = `${this.$publicResourcesUrlDownload}${item.url}&fileName=${this.currentCounselor.firstName + '_' + this.currentCounselor.mobile + '_' + item.type + '.jpg'}`
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .quaImages {
    width: 117px;
    height: 155px;
  }

  .specification-table-div {
    margin-top: 20px;
    padding: 0 .2rem .2rem;
  }

  .specification-table {
    display: table !important;
    width: 8rem;
    border-collapse: collapse !important;

    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row !important;
      padding: 0 !important;
      list-style-type: none;
      justify-content: center !important;
      border-bottom: 1px solid #C6C9D3;
      color: #5B5B5B !important;
    }

    td {
      color: #5B5B5B !important;
      text-align: center;
      justify-content: flex-start !important;
      padding: 10px;
    }
  }

</style>
